import { useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  Box,
} from "@mui/material";
import Iconify from "./iconify";
import Scrollbar from "./scrollbar";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export default function LeaderboardTable({ formaData }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const [setOpenId] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortDirection("asc");
    }
  };

  const renderSortIcons = (column) => {
    const isActive = sortBy === column;
    const isAsc = sortDirection === "asc";

    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Iconify
          icon="eva:arrow-ios-upward-fill"
          sx={{
            fontSize: 12,
            color: isActive && isAsc ? "#667eea" : "#ccc",
            mb: "-8px",
            cursor: "pointer",
            "&:hover": { color: "#667eea" },
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleSort(column);
          }}
        />
        <Iconify
          icon="eva:arrow-ios-downward-fill"
          sx={{
            fontSize: 12,
            color: isActive && !isAsc ? "#667eea" : "#ccc",
            cursor: "pointer",
            "&:hover": { color: "#667eea" },
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleSort(column);
          }}
        />
      </Box>
    );
  };

  const formatCurrencyDisplay = (value) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <img
          src="/assets/icons/ufcoin.svg"
          alt="coin"
          style={{ width: 16, height: 16 }}
        />
        {value}
      </Box>
    );
  };

  // const sortedData = sortBy
  //   ? [...mockData].sort((a, b) => {
  //       const aValue = a[sortBy];
  //       const bValue = b[sortBy];

  //       if (sortDirection === "asc") {
  //         return aValue > bValue ? 1 : -1;
  //       } else {
  //         return aValue < bValue ? 1 : -1;
  //       }
  //     })
  //   : mockData;

  const handleViewLineup = () => {
    navigate("/dashboard/user-football-lineup");
  };

  return (
    <>
      <Card>
        <Scrollbar>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="leaderboard table">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
                  <TableCell sx={{ fontWeight: 600 }}>User ID</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Username</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                    >
                      <span>Entry date</span>
                      {renderSortIcons("entryDate")}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                    >
                      <span>Entry fee</span>
                      {renderSortIcons("entryFee")}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                    >
                      <span>Pts</span>
                      {renderSortIcons("points")}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                    >
                      <span>Rank</span>
                      {renderSortIcons("rank")}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                    >
                      <span>Prize</span>
                      {renderSortIcons("prize")}
                    </Box>
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {formaData.leaderboard?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <TableCell>{row.userId}</TableCell>
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography
                          sx={{
                            color: "#667eea",
                            fontWeight: 600,
                          }}
                          variant="body2"
                        >
                          {row.name}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell>
                      {moment(row.entryDate).format("h:mma MMM D, YYYY")}
                    </TableCell>
                    <TableCell>{formaData.entryFee}</TableCell>
                    <TableCell>{row.score}</TableCell>
                    <TableCell>{row.rank}</TableCell>
                    <TableCell>{formatCurrencyDisplay(row.prize)}</TableCell>
                    <TableCell align="right">
                      <IconButton
                        size="large"
                        color="inherit"
                        onClick={handleOpenMenu}
                        id={row.userId}
                      >
                        <Iconify icon="eva:more-vertical-fill" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>
      </Card>

      {/* Actions Menu */}
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 160,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={handleViewLineup}
          sx={{
            backgroundColor: "#667eea",
            color: "white",
            "&:hover": {
              backgroundColor: "#5a6fd8",
            },
          }}
        >
          <Iconify icon="eva:eye-outline" sx={{ mr: 2 }} />
          View lineup
        </MenuItem>
        <MenuItem onClick={handleCloseMenu}>
          <Iconify icon="eva:person-delete-outline" sx={{ mr: 2 }} />
          Remove user
        </MenuItem>
      </Popover>
    </>
  );
}
